export function formatEventSubtitle({
  date,
  time,
  venueName,
  venueLocation,
  includeLocation,
}: {
  date: string;
  time: string;
  venueName?: string | null;
  venueLocation?: string | null;
  includeLocation: boolean;
}) {
  const venue = includeLocation
    ? [venueName, venueLocation].filter(Boolean).join(', ')
    : venueName || venueLocation || '';

  return [date, time, venue].filter(Boolean).join(' • ');
}

export function formatTravelerLabel(count: number) {
  return count === 1 ? '1 traveler' : `${count} travelers`;
}
